import { render, staticRenderFns } from "./edit-answer.vue?vue&type=template&id=ce331302&scoped=true"
import script from "./edit-answer.vue?vue&type=script&lang=js"
export * from "./edit-answer.vue?vue&type=script&lang=js"
import style0 from "./edit-answer.vue?vue&type=style&index=0&id=ce331302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce331302",
  null
  
)

export default component.exports